import React, {forwardRef, useCallback, useState} from 'react'
import _ from 'lodash'
import { Form } from 'antd';
import BaseModalForm from 'components/BaseModalForm';
import { FieldTypes } from 'utils/formUtils';
import Vocabulary from 'components/Vocabulary';
import SubProductAPI from 'restAPI/SubProductAPI';
import ProductAPI from 'restAPI/ProductAPI';
import SubProductEnvironmentTypeAPI from 'restAPI/SubProductEnvironmentTypeAPI';
import message from 'components/CustomMessage';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { envParseSelectOptions } from 'views/Findings/Constants';

const EditZoneForm = forwardRef(({afterClose, recordData}, ref) => {
    const {id, isDeleted} = recordData || ''
    const [data, setData] = useState(() => getInitialData(recordData));
    const [form] = Form.useForm();

    const submitData = async () => {
        await form.validateFields();
        await ToolsIntegrationsAPI[id && !isDeleted ? 'updateRoute53' : 'integrateRoute53'](data, id).promise
        message.success('Successfully Edited!')
    }

    const onValuesChange = useCallback((changes, values) => {
        if(changes.productId){
            form.setFieldsValue({ subProductId: null, environmentId: null });
        } else if (changes.subProductId){
            form.setFieldsValue({ environmentId: null });
        }
        setData(data => ({...data, ...values}));
    }, [form])


    const fields = [{
        label: <Vocabulary name="product" />,
        name: "productId",
        type: FieldTypes.SELECT,
        required: true,
        props: {
            api: ProductAPI.getAllQuick,
        }
    }, {
        label: <Vocabulary name="subProduct" />,
        name: "subProductId",
        type: FieldTypes.SELECT,
        required: true,
        props: data.productId && {
            api: SubProductAPI.getAllQuick,
            apiParams: data.productId,
        }
    },{
        label: "Environment",
        name: "environmentId",
        type: FieldTypes.SELECT,
        required: true,
        props: data.subProductId && {
            api: SubProductEnvironmentTypeAPI.getAllQuick,
            parseSelectOptions: envParseSelectOptions,
            apiParams: data.subProductId,
        }
    }]

    return (
        <BaseModalForm
            ref={ref}
            onOk={submitData}
            fields={fields} 
            modalProps={baseModalProps}
            title= {`Edit ${data?.recordName} DNS Records`}
            initialValues={data} 
            form={form} 
            afterClose={afterClose} 
            onValuesChange={onValuesChange}>
        </BaseModalForm>
    )
})

export default EditZoneForm

const baseModalProps = {
    okText: "Edit",
}

function getInitialData(data = {}) {
    if(_.isEmpty(data)) {
        return data
    }
    const newData =  _.pick(data, "ttl", "recordType", "recordValues", "recordName", "productId", "subProductId", "environmentId")
    _.assign(newData, {"hostedZone": {"id": data?.hostedZone?.id}})
    return newData
}
